import React from 'react';
import { isMobile, isIOS, isAndroid } from 'react-device-detect';
import ImageBW from '../../components/ImageBoundsWrapper';
import ResetPassword from '../../screens/ResetPassword';
import theme from 'shared/assets/style/theme';
import PlayerInterface from 'shared/api/PlayerInterface';
import QueryParamsProxy from 'shared/utils/queryParamProxy';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';

const LINK = ENVIRONMENT_VARIABLES.MOBILE_WEB_ONE_LINK;

export default class SmartBanner extends React.Component {
  state = {
    isShown: true,
    link: LINK,
    showRecoverPass: {},
  };

  hideBanner = () => {
    this.setState({
      isShown: false,
    });
  };

  componentDidMount() {
    this.checkRecoverPassRequest();
  }

  checkRecoverPassRequest = async () => {
    if (!isMobile) return;
    let urlParams = QueryParamsProxy.getAllParams();
    if (!urlParams) return;
    let id = urlParams.i;
    let token = urlParams.t;
    let platform = urlParams.platform;
    if (id && token && platform) {
      let recoverRequest = await PlayerInterface.recoverPasswordTokenCheck({ id, token });
      if (!recoverRequest.success) {
        this.setState({
          showRecoverPass: {
            visible: true,
            invalid: true,
            message: recoverRequest.error,
          },
        });
      } else {
        this.setState({
          showRecoverPass: {
            visible: true,
            invalid: false,
            id,
            token,
          },
        });
      }
    }
  };

  _style = {
    modalStyle: {
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: window.matchMedia('(orientation: landscape)').matches ? '0 40vmin' : '0 2vmin',
    },
    modalContainerStyle: {
      height: window.matchMedia('(orientation: landscape)').matches ? '85vh' : '56vh',
      width: '100%',
      marginTop: '-1vw',
      marginBottom: '-1vw',
    },
  };

  render() {
    return isMobile && this.state.isShown ? (
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          display: 'flex',
          width: '100%',
          height: '80px',
          lineHeight: '80px',
          fontFamily: 'Helvetica Neue, sans-serif',
          background: theme.palette.common[13],
          zIndex: 9998,
          overflow: 'hidden',
          justifyContent: 'space-between',
          ...this.props.style,
        }}
      >
        <ResetPassword
          isVisible={this.state.showRecoverPass.visible}
          title={getText(TEXT_KEY.RESET_PASSWORD_TITLE)}
          closeModal={() => this.setState({ showRecoverPass: { ...this.state.showRecoverPass, visible: false } })}
          zIndex={101}
          navigation={this.props.navigation}
          modalStyle={this._style.modalStyle}
          modalContainerStyle={this._style.modalContainerStyle}
          invalid={this.state.showRecoverPass.invalid}
          errorMessage={this.state.showRecoverPass.message}
          recoverId={this.state.showRecoverPass.id}
          recoverToken={this.state.showRecoverPass.token}
        />
        <div style={{ display: 'flex' }}>
          <div onClick={this.hideBanner} style={{ display: 'block', width: '30px', margin: '20px' }}>
            <ImageBW
              source={require(asset`CloseButton@3x.png`)}
              ibw={require(asset`CloseButton.ibw`)}
              manualAssetScale={3}
              style={{
                objectFit: 'contain',
                height: '100%',
                width: '100%',
              }}
              innerStyle={{
                cursor: 'pointer',
              }}
              alt="Close"
            />
          </div>
          <div style={{ display: 'block', width: '100px', margin: '20px' }}>
            <ImageBW
              source={require(asset`StarPlayLogo-1.png`)}
              ibw={require(asset`CloseButton.ibw`)}
              manualAssetScale={3}
              style={{
                objectFit: 'contain',
                height: '100%',
                width: '100%',
              }}
              innerStyle={{
                cursor: 'pointer',
              }}
              alt="Close"
            />
          </div>
          <a href={this.state.link} style={{ color: theme.palette.common[0] }}>
            {getText(TEXT_KEY.AVAILABLE_IN)}{' '}
            {isIOS ? 'App Store' : isAndroid ? 'Google Play' : getText(TEXT_KEY.NOT_AVAILABLE)}
          </a>
        </div>
      </div>
    ) : (
      <div />
    );
  }
}

